module.exports = __webpack_public_path__ + "static/media/menara-kl.1ce9bf90.jpg";